import React from 'react';
import PropTypes from 'prop-types';
import {DragLayer as DragLayerVendor} from 'react-dnd';
import * as DraggableItemType from 'common/components/dashboard/constants/draggable-item-type';

import GhostCard from 'common/components/ghost-card';
import {cardsWithoutNameInputs} from 'common/utils/reports-util';

const layerStyles = {
  position: 'fixed',
  pointerEvents: 'none',
  zIndex: 100,
  left: 0,
  top: 0,
  width: '100%',
  height: '100%',
};

function getItemStyles(props) {
  const {initialOffset, currentOffset} = props;
  if (!initialOffset || !currentOffset) {
    return {
      display: 'none',
    };
  }
  const {x, y} = currentOffset;
  const transform = `translate(${x}px, ${y}px)`;
  return {
    transform,
    WebkitTransform: transform,
  };
}

class DragLayer extends React.Component {
  static propTypes = {
    currentOffset: PropTypes.shape({
      x: PropTypes.number.isRequired,
      y: PropTypes.number.isRequired,
    }),
    initialOffset: PropTypes.shape({
      x: PropTypes.number.isRequired,
      y: PropTypes.number.isRequired,
    }),
    isDragging: PropTypes.bool.isRequired,
    item: PropTypes.object,
    itemType: PropTypes.string,
  };

  render() {
    const {item, itemType, isDragging, currentOffset} = this.props;

    if (!isDragging || !currentOffset || itemType !== DraggableItemType.CARD) {
      return null;
    }

    const {report} = item;
    const title =
      cardsWithoutNameInputs.indexOf(report.type.id) > -1 ? null : report.name;

    return (
      <div
        className={'ContainerMain ContainerMain--no-transition'}
        style={layerStyles}>
        <div
          className={'ContainerCard ContainerCard--dragged'}
          style={{
            ...getItemStyles(this.props),
            width: `${item.width}px`,
          }}>
          <GhostCard title={title} />
        </div>
      </div>
    );
  }
}

export default DragLayerVendor((monitor) => ({
  item: monitor.getItem(),
  itemType: monitor.getItemType(),
  initialOffset: monitor.getInitialSourceClientOffset(),
  currentOffset: monitor.getSourceClientOffset(),
  isDragging: monitor.isDragging(),
}))(DragLayer);
